module.exports = __webpack_public_path__ + "static/media/img-about-usp3-mobile@2x.829416b5.jpg";